import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import { Swipeable } from 'react-swipeable';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './Duperswiper.scss';
const Duperswiper = ({ children, deviation, width, height, navigation: { nextItem, prevItem }, isEnabled, moveNext, movePrev, duperActive, preloadEnabled, fetchRelatedContentForDeviation, hasRootStream, relatedLoadingState })=>{
    const isLazyRelated = useFlag('lazy_related');
    const [xOffset, setOffset] = useState(0);
    const [requestedRelated, setRequestedRelated] = useState(false);
    const isDuperDisabled = !preloadEnabled;
    const maybeLoadRelated = useCallback(()=>{
        var _deviation_extended;
        if (!isLazyRelated || ((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.relatedContent) || hasRootStream || relatedLoadingState !== 'idle' || duperActive) {
            return;
        }
        fetchRelatedContentForDeviation && fetchRelatedContentForDeviation(deviation, false);
        setRequestedRelated(true);
    }, [
        deviation,
        fetchRelatedContentForDeviation,
        hasRootStream,
        isLazyRelated,
        relatedLoadingState,
        duperActive
    ]);
    const onSwipingLeft = useCallback((absX)=>{
        if (!nextItem) {
            if (xOffset) {
                setOffset(0);
            }
            return;
        }
        setOffset(-absX);
    }, [
        nextItem,
        xOffset
    ]);
    const onSwipingRight = useCallback((absX)=>{
        // do nothing if there's nothing in the current direction
        if (!prevItem) {
            if (xOffset) {
                setOffset(0);
            }
            return;
        }
        setOffset(absX);
    }, [
        prevItem,
        xOffset
    ]);
    const onSwiping = useCallback(({ dir, absX })=>{
        switch(dir){
            case 'Left':
                onSwipingLeft(absX);
                return;
            case 'Right':
                onSwipingRight(absX);
                return;
            default:
        }
    }, [
        onSwipingLeft,
        onSwipingRight
    ]);
    const onSwipedLeft = useCallback((sw)=>{
        maybeLoadRelated();
        if (!nextItem || sw.deltaX < 40) {
            setOffset(0);
            return;
        }
        setOffset(width ? -width : '-100%');
        moveNext();
    }, [
        moveNext,
        nextItem,
        width,
        maybeLoadRelated
    ]);
    const onSwipedRight = useCallback((sw)=>{
        maybeLoadRelated();
        if (!prevItem || sw.deltaX > -40) {
            setOffset(0);
            return;
        }
        setOffset(width || '100%');
        movePrev();
    }, [
        movePrev,
        prevItem,
        width,
        maybeLoadRelated
    ]);
    if (!isEnabled || isDuperDisabled) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children(deviation));
    }
    const transformStyle = {
        transform: `translateX(${xOffset}px)`
    };
    return /*#__PURE__*/ React.createElement(Swipeable, {
        trackMouse: true,
        onSwiping: onSwiping,
        onSwipedLeft: onSwipedLeft,
        onSwipedRight: onSwipedRight,
        className: s['swipeable']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            width,
            height
        }
    }, /*#__PURE__*/ React.createElement("div", {
        style: transformStyle,
        className: classnames(s['transform'], requestedRelated && relatedLoadingState === 'fetching' && s['loading'])
    }, children(deviation)), prevItem && Number(xOffset) > 0 && /*#__PURE__*/ React.createElement("div", {
        style: transformStyle,
        className: classnames(s['preview'], s['prev'])
    }, children(prevItem)), nextItem && Number(xOffset) < 0 && /*#__PURE__*/ React.createElement("div", {
        style: transformStyle,
        className: classnames(s['preview'], s['next'])
    }, children(nextItem))));
};
Duperswiper.displayName = 'Duperswiper';
export default Duperswiper;
